// extracted by mini-css-extract-plugin
export default {"LegendWrapper":"legend_LegendWrapper_R4gmx","LegendItem":"legend_LegendItem_bmElx","LegendItem_unavailable":"legend_LegendItem_unavailable_dotRy"};